// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import AdminHeader from 'components/common/AdminHeader';
import Title from 'components/text/Title';
import Button from 'components/common/Button';
import OrganizationForm from 'components/forms/OrganizationForm';
import OrganizationsTable from './OrganizationsTable';
// APOLLO
import getOrganizationsQuery from 'ApolloClient/Queries/getOrganizations';
import createOrganization from 'ApolloClient/Mutations/createOrganization';
import { compose, graphql } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

class AdminOrganizations extends React.PureComponent {
  state = {
    showAddOrgForm: false,
  }

  toggleForm = () => {
    this.setState({ showAddOrgForm: !this.state.showAddOrgForm });
  };

  handleCreateNewOrganization = async (newOrg) => {
    let variables = {
      params: {
        ...newOrg,
      }
    }

    try {
      await this.props.createOrganization({ variables });
    }
    catch(err){
      return ErrorHelpers.handleError(err)
    }
    this.toggleForm();
    window.location.reload();

  }

  render() {
    return (
      <PageContainer>
      {!this.state.showAddOrgForm 
      ? (<React.Fragment>
        <AdminHeader header="Organizations " action={<Button style={{marginBottom: 20}} onClick={this.toggleForm}>+ New Organization</Button>} />
          <OrganizationsTable organizations={this.props.getOrganizationsQuery.getOrganizations} />
        </React.Fragment>) 
      : (
          <React.Fragment>
          <AdminHeader header="Add New Organization " action={<Button type="dashed" style={{marginBottom: 20}} onClick={this.toggleForm}>Cancel</Button>} />
          <div>
                <OrganizationForm handleSubmit={this.handleCreateNewOrganization} />
              </div>
              </React.Fragment>
          )}
      </PageContainer>
    );
  }
}

export default compose(
  graphql(createOrganization, { name: 'createOrganization'}),
  graphql(getOrganizationsQuery, { name: 'getOrganizationsQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'getOrganizationsQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getOrganizationsQuery' }),
)(AdminOrganizations);



// WEBPACK FOOTER //
// ./src/routes/admin-organizations/index.js